import * as React from "react";
const SvgCheckboxDefault = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path fill="#fff" d="M1 9a8 8 0 0 1 8-8h6a8 8 0 0 1 8 8v6a8 8 0 0 1-8 8H9a8 8 0 0 1-8-8z" />
    <path
      fill="#A6A6A6"
      fillRule="evenodd"
      d="M15 2.6H9A6.4 6.4 0 0 0 2.6 9v6A6.4 6.4 0 0 0 9 21.4h6a6.4 6.4 0 0 0 6.4-6.4V9A6.4 6.4 0 0 0 15 2.6M9 1a8 8 0 0 0-8 8v6a8 8 0 0 0 8 8h6a8 8 0 0 0 8-8V9a8 8 0 0 0-8-8z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCheckboxDefault;
